export default __webpack_public_path__ + "assets/ico_block_book-816930eb.svg";